import React from 'react';
import { Typography } from '@material-ui/core';
import translationPropType from '../../../proptypes/translationPropType';

const NoResultMessage = ({ translation }) => (
    <Typography variant="body2">
        {translation.NO_RESULT_MESSAGE}
    </Typography>
);

NoResultMessage.propTypes = {
    translation: translationPropType.isRequired,
};

export default NoResultMessage;
